<template lang="pug">
  SspLayout(area="core")
    .audit-trail
      form.panel.panel-default.form-horizontal(role="form" @submit.prevent="fetchData")
        .panel-heading.panel-title Filter Definition
        .panel-body
            .form-group
              label.col-sm-2.control-label Object Type
              .col-sm-2
                input.form-control(v-model="filter.objectType")

              label.col-sm-2.control-label Object IDs
              .col-sm-2
                input.form-control(v-model="filter.objectId")

              label.col-sm-2.control-label Action
              .col-sm-2
                select.form-control(v-model="filter.operation")
                  option(v-for="action in actions") {{action}}

            .form-group
              label.col-sm-2.control-label Usernames
              .col-sm-2
                input.form-control(v-model="filter.username")

              label.col-sm-2.control-label Start Time
              .col-sm-2
                Datepicker(v-model="filter.startTime")

              label.col-sm-2.control-label End Time
              .col-sm-2
                Datepicker(v-model="filter.endTime")

        .panel-footer
          .text-right
            button.btn.btn-primary(type="submit") Filter
            button.btn.btn-default.ml10(type="button" @click="clear()") Clear
      GenericTable()
        tr(slot="thead")
          th Type
          th Id
          th Operation
          th Timestamp
          th User
          th Changes
        tr(v-for="at in auditTrail")
          td.clickable(@click="setObjectType(at.objectType)") {{at.objectType}}
          td.clickable(@click="setObjectId(at.pk)") {{at.pk}}
          td.clickable(@click="setOperation(at.operation)") {{at.operation}}
          td {{at.timestamp | date}}
          td
            span.clickable(@click="setUsername(at.user.username)" v-if="at.user") {{at.user.username}}
          td(style="max-width: 700px;")
            ul(v-for="ch in at.changes.change")
              li(v-if="ch.ref.oldRef") {{ch.property}}
                span.ml5 [{{ch.ref.type}}] -
                  strike.text-muted.ml5 {{ch.ref.oldRef}}
              li(v-if="ch.ref.newRef") {{ch.property}}
                span.ml5 [{{ch.ref.type}}] -
                  em.text-muted.ml5 {{ch.ref.newRef}}

    IndefinitePagination(ref="pagination" :fetch="fetchData" urlPageParam="offset")
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import Core from '@/service/apis/Core'
import { dateFilter } from '@/filters/filters'
import Datepicker from '@/components/common/Datepicker'
import IndefinitePagination from '@/components/common/IndefinitePagination'

export default {
  data() {
    return {
      errorMsg: null,
      auditTrail: null,
      offset: 0,
      actions: ['', 'CREATE', 'UPDATE', 'DELETE'],
      filter: this.initialFilterData(),
      noNext: false,
      loading: false
    }
  },
  methods: {
    next() {
      this.offset = this.offset + 1
      this.$refs.pagination.reload()
    },
    prev() {
      this.offset = this.offset - 1
      this.$refs.pagination.reload()
    },
    setUsername(name) {
      this.filter.username = name
      this.$refs.pagination.reload()
    },
    setObjectType(type) {
      this.filter.objectType = type
      this.$refs.pagination.reload()
    },
    setObjectId(id) {
      this.filter.objectId = id
      this.$refs.pagination.reload()
    },
    setOperation(op) {
      this.filter.operation = op
      this.$refs.pagination.reload()
    },
    clear() {
      this.filter = this.initialFilterData()
      this.$refs.pagination.reload()
    },
    initialFilterData() {
      return {
        objectType: null,
        objectId: null,
        operation: null,
        username: null,
        startTime: null,
        endTime: null,
        page: 0
      }
    },
    fetchData(params) {
      const req = params
      this.loading = true
      req.filter = {
        objectTypes: this.filter.objectType ? this.filter.objectType.split(',') : null,
        objectIds: this.filter.objectId ? this.filter.objectId.split(',') : null,
        usernames: this.filter.username ? this.filter.username.split(',') : null,
        operations: this.filter.operation ? this.filter.operation.split(',') : null,
        startTime: this.filter.startTime ? this.filter.startTime : null,
        endTime: this.filter.endTime ? this.filter.endTime : null
      }

      return Core.listAuditTrail(req)
        .then((resp) => {
          this.auditTrail = resp.data.entries.entry
          this.loading = false
          return resp.data.hasMore
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  components: {
    GenericTable,
    IndefinitePagination,
    Datepicker
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/management/AuditTrail.vue